import { render, staticRenderFns } from "./PagesBlock.vue?vue&type=template&id=6ca64cd6&scoped=true&"
import script from "./PagesBlock.vue?vue&type=script&lang=js&"
export * from "./PagesBlock.vue?vue&type=script&lang=js&"
import style0 from "./PagesBlock.vue?vue&type=style&index=0&id=6ca64cd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca64cd6",
  null
  
)

export default component.exports